module.exports = __webpack_public_path__ + "badge-activity.svg?e506ee7f1ed56c72a3a4ce7105fe062f";


//////////////////
// WEBPACK FOOTER
// ./public/images/site/badge-activity.svg
// module id = 477
// module chunks = 0